import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-svg-holder',
  standalone: true,
  imports: [],
  templateUrl: './svg-holder.component.html',
  styleUrl: './svg-holder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgHolderComponent {

}
